import template from './stSelectFilter.html';
import controller from './stSelectFilter.controller';

let stSelectFilterComponent = {
  restrict: 'E',
  bindings: {
      filter: '=',
      items: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default stSelectFilterComponent;



// WEBPACK FOOTER //
// ./client/app/common/stSelectFilter/stSelectFilter.component.js